import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { formatMoney, getDivisionName } from "../../../constants/utils";
import moment from "moment";

const CollapsibleTableForProvisionHistory = ({ modalData }) => {
  // Define months to show
  const monthListTableHeader = [
    "Live (Apr 2025)",
    "Dec 2024",
    "Sep 2024",
    "June 2024",
  ];
  const monthListTableBody = [
    "April 2025",
    "December 2024",
    "September 2024",
    "June 2024",
  ];

  // Group data by unique customerCode + division
  const groupedData = modalData.reduce((acc, item) => {
    const key = `${item.customerCode}_${item.division}`;
    const month = moment(item.createdDate).format("MMMM YYYY");

    if (!acc[key]) {
      acc[key] = {
        customerName: item.customerName,
        customerCode: item.customerCode,
        division: item.division,
        provisions: {},
      };
    }

    if (monthListTableBody.includes(month)) {
      acc[key].provisions[month] = formatMoney(
        (item.provisionAmount || 0).toFixed(0)
      );
    }

    return acc;
  }, {});

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: "black",
                color: "white",
                fontWeight: "bold",
                minWidth: 180,
              }}
            >
              Customer
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "black",
                color: "white",
                fontWeight: "bold",
                minWidth: 120,
              }}
            >
              Code
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "black",
                color: "white",
                fontWeight: "bold",
                minWidth: 120,
              }}
            >
              Division
            </TableCell>
            {monthListTableHeader.map((month) => (
              <TableCell
                key={month}
                sx={{
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "bold",
                  minWidth: 120,
                }}
              >
                {month}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {Object.values(groupedData). */}
          {Object.values(groupedData)
            .filter((data) => {
              // Check if all provision values are 0 or undefined
              const allZeroOrDash = monthListTableBody.every((month) => {
                const value = data.provisions[month];
                return !value || value === 0 || value === "-" || value === "0";
              });
              return !allZeroOrDash;
            })
            /* .sort((a, b) => {
              const aVal = parseFloat(a.provisions["April 2025"]) || 0;
              const bVal = parseFloat(b.provisions["April 2025"]) || 0;
              return bVal - aVal; // Descending order
            }) */
            .map((data, index) => (
              <TableRow key={`${data.customerCode}_${data.division}_${index}`}>
                <TableCell>{data.customerName}</TableCell>
                <TableCell>{data.customerCode}</TableCell>
                <TableCell>{getDivisionName(data.division)}</TableCell>
                {monthListTableBody.map((month) => (
                  <TableCell key={month}>
                    {data.provisions[month] || "-"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CollapsibleTableForProvisionHistory;
